// @ts-strict-ignore
import React, { useContext, useMemo } from 'react';
import { AggregationsSubEditorContainer } from 'flow/editor/components/aggregations';
import { RuleBuilderContext } from '../../context';
import { useAppDispatch } from '~/store/reduxHooks';
import { resetSubEditor } from 'flow/store/redux/thunks';

const AggregationsWrapper = () => {
  const dispatch = useAppDispatch();
  const { keyboardFocus } = useContext(RuleBuilderContext);

  const handleClose = useMemo(() => () => {
    dispatch(resetSubEditor());
    keyboardFocus.enable();
  }, [dispatch, keyboardFocus]);

  return (
    <AggregationsSubEditorContainer onClose={handleClose} />
  );
};

export default AggregationsWrapper;
